import * as runtypes from 'runtypes'
import { apiFetch } from './helpers'

export const GeneratePDFRequest = runtypes.Record({
	html: runtypes.String,
	className: runtypes.String
})

export type GeneratePDFRequest = runtypes.Static<
	typeof GeneratePDFRequest
>

export const GeneratePDFResponseData = runtypes.Record({
	documentBase64: runtypes.String
})
export type GeneratePDFResponseData = runtypes.Static<
	typeof GeneratePDFResponseData
>

export const generatePDF = async (params: GeneratePDFRequest) => {
	return apiFetch(
		GeneratePDFResponseData,
		'/api/generatePdf',
		params,
	)
}

